import { taskService } from '@/services'

export default async (bookId) => {
  const { data } = await taskService.getTaskTags([bookId])

  const rows = await taskService.getRows({ bookId })

  if (rows?.data?.taskRows?.length === 0) return

  await taskService.updateTaskTag({
    name: 'example',
    id: data.tags[2].id,
    bookId
  })

  return taskService.create({
    title: 'This is a task',
    subTitle: 'Add tasks and drag&drop them to other parts of the board',
    additionalInfo: '',
    isUrgent: true,
    position: '0',
    taskRowId: rows.data.taskRows[0].id,
    bookId: bookId,
    tagIds: [data.tags[2].id, data.tags[4].id]
  })
}
